import React, {
  useEffect,
  useReducer,
  useState,
  useRef,
  useContext,
} from 'react';
import { Col, Form, Modal, Radio, Row, Table, Tabs } from 'antd';
import { Checkbox, InfoBox, MobileTabBar, Select } from 'components';
import classNames from 'classnames';

import ExportFileIcon from 'assests/icons/export-file.icon';
import GroupsIcon from 'assests/icons/groups.icon';
import DeleteIcon from 'assests/icons/delete.icon';
import EditIcon from 'assests/icons/edit.icon';
import NewContact from 'assests/icons/new-contact.icon';
import ImportExcelIcon from 'assests/icons/import-excel.icon';

import './guide-page.less';
import '../Checkbox/checkbox.less';
import { Button, Input, SelectFile } from '../index';
import RightChevronIcon from 'assests/icons/right-chevron.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import UploadIcon from 'assests/icons/upload.icon';
import SearchIcon from 'assests/icons/search.icon';
import { DimensionsContext } from 'context/dimensions.context';

const { TabPane } = Tabs;

const GuidePage = () => {
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [selectedItems, setSelectedItems] = useState(null);
  const [newGroupModal, setNewGroupModal] = useState(false);
  const [importFileModal, setImportFileModal] = useState(false);
  const [rowEditModal, setRowEditModal] = useState(false);
  const [addRowModal, setAddRowModal] = useState(false);
  const [changeGroupModal, setChangeGroupModal] = useState(false);
  const [testSelectedRow, setTestSelectedRow] = useState([]);

  const [contentName, setContentName] = useState('group--1');
  const [editGroupName, setEditGroupName] = useState(false);

  const [fileList, setFileList] = useState([]);
  const [groupImportFile, setGroupImportFile] = useState(false);
  const [groupName, setGroupName] = useState('Tüm Kayıtlar');

  const { isPc } = useContext(DimensionsContext);
  const [form] = Form.useForm();

  const columns = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'phone',
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: () => (
            <div style={{ textAlign: 'right' }}>
              {testSelectedRow.length > 0 ? (
                <span>{testSelectedRow.length} Kişi Seçildi</span>
              ) : null}
            </div>
          ),
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {testSelectedRow.length > 0 ? (
                <div className="group-actions">
                  <button type="button">
                    <ExportFileIcon />
                    <span>Dışa aktar</span>
                  </button>
                  <button
                    onClick={() => {
                      setChangeGroupModal(true);
                    }}
                    type="button"
                  >
                    <GroupsIcon />
                    <span>Grupla</span>
                  </button>
                  <button type="button">
                    <DeleteIcon />
                    <span>Sil</span>
                  </button>
                </div>
              ) : null}
            </div>
          ),
          dataIndex: 'mail',
          render: (text) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button
                  onClick={() => {
                    setRowEditModal(true);
                  }}
                  type="button"
                >
                  <EditIcon />
                </button>
                <button type="button">
                  <DeleteIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
  const mobileColumns = [
    {
      title: '',
      dataIndex: 'check',
      fixed: 'left',
      width: 50,
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',

          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
          fixed: 'left',
          width: 50,
        },
      ],
    },
    {
      title: 'Telefon No',
      fixed: 'left',
      width: 110,
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'phone',
          fixed: 'left',
          width: 110,
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: () => (
            <div style={{ textAlign: 'right' }}>
              {testSelectedRow.length > 0 ? (
                <span>{testSelectedRow.length} Kişi Seçildi</span>
              ) : null}
            </div>
          ),
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {testSelectedRow.length > 0 ? (
                <div className="group-actions">
                  <button type="button">
                    <ExportFileIcon />
                    <span>Dışa aktar</span>
                  </button>
                  <button
                    onClick={() => {
                      setChangeGroupModal(true);
                    }}
                    type="button"
                  >
                    <GroupsIcon />
                    <span>Grupla</span>
                  </button>
                  <button type="button">
                    <DeleteIcon />
                    <span>Sil</span>
                  </button>
                </div>
              ) : null}
            </div>
          ),
          dataIndex: 'mail',
        },
      ],
      render: (text) => (
        <>
          <span>{text}</span>
          <div className="row-edit">
            <button
              onClick={() => {
                setRowEditModal(true);
              }}
              type="button"
            >
              <EditIcon />
            </button>
            <button type="button">
              <DeleteIcon />
            </button>
          </div>
        </>
      ),
    },
  ];
  const columnsV2 = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'phone',
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: '',
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions table-group-actions--v2">
              {testSelectedRow.length > 0 ? (
                <>
                  <span>{testSelectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions" style={{ width: '105px' }}>
                    <button type="button">
                      <DeleteIcon />
                      Sil
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'mail',
          render: (text) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button
                  onClick={() => {
                    setRowEditModal(true);
                  }}
                  type="button"
                >
                  <EditIcon />
                </button>
                <button type="button">
                  <DeleteIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
  const mobileColumnsV2Test = [
    {
      title: '',
      dataIndex: 'check',
      fixed: 'left',
      width: 50,
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          fixed: 'left',
          width: 50,
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      fixed: 'left',
      width: 110,
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'phone',
          fixed: 'left',
          width: 110,
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: '',
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions table-group-actions--v2">
              {testSelectedRow.length > 0 ? (
                <>
                  <span>{testSelectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions" style={{ width: '105px' }}>
                    <button type="button">
                      <DeleteIcon />
                      Sil
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'mail',
          render: (text) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button
                  onClick={() => {
                    setRowEditModal(true);
                  }}
                  type="button"
                >
                  <EditIcon />
                </button>
                <button type="button">
                  <DeleteIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];

  const mobileColumnsV2 = [
    {
      title: 'Tümünü Seç',
      dataIndex: 'phone',
      fixed: 'left',
      width: 110,
    },
    {
      title: '',
      dataIndex: 'name',
    },
    {
      title: () => (
        <div className="flex align-items-center justify-end">
          {selectedItems ? (
            <>
              <span className="margin-right-spacing-xs">
                {selectedItems} Kişi Seçildi
              </span>
              <div className="group-actions">
                <button type="button">
                  <DeleteIcon />
                  Sil
                </button>
              </div>
            </>
          ) : null}
        </div>
      ),
      dataIndex: 'mail',
      render: (text) => (
        <>
          <span>{text}</span>
          <div className="row-edit">
            <button
              onClick={() => {
                setRowEditModal(true);
              }}
              type="button"
            >
              <EditIcon />
            </button>
            <button type="button">
              <DeleteIcon />
            </button>
          </div>
        </>
      ),
    },
  ];
  const data = [
    {
      key: '1',
      phone: '+905300854144',
      name: 'Ezgi Özge Albayrak',
      mail: 'mucahid.kirtay@gmail.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '1',
      phone: '+90512499909',
      name: 'Ezgi Özge Albayrak',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '1',
      phone: '+90512499909',
      name: 'Ezgi Özge Albayrak',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '1',
      phone: '+90512499909',
      name: 'Ezgi Özge Albayrak',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '1',
      phone: '+90512499909',
      name: 'Ezgi Özge Albayrak',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '1',
      phone: '+90512499909',
      name: 'Ezgi Özge Albayrak',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '1',
      phone: '+90512499909',
      name: 'Ezgi Özge Albayrak',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '1',
      phone: '+90512499909',
      name: 'Ezgi Özge Albayrak',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '2',
      phone: '+90512499909',
      name: 'Ecem Tunca',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '3',
      phone: '+90512499909',
      name: 'Emin Kağan Özkan',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '4',
      phone: '+90512499909',
      name: 'Mücahid Kırtay',
      mail: 'mehmet.ozmen@ibm.com',
    },
    {
      key: '5',
      phone: '+90512499909',
      name: 'Burçe Çelik',
      mail: 'mehmet.ozmen@ibm.com',
    },
  ];
  const changeGroupList = [
    'Samsung Kullanıcıları',
    'General Mobile Kullanıcıları',
    'Bizden Telefon Almamış Müşterilerimiz',
    'Son Telefon Satın Alma Tarihi 1 Yıldan Son Telefon Satın Alma Tarihi 1 Yıldan Ö...',
    'Lorem ipsum2 2dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum3 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum4 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum5 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
    'Lorem ipsum6 dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum Lorem ipsum dolor sit amet, lorem ipsum .',
  ];

  const selectFileRef = useRef(null);

  const [arrayList, setArrayList] = useState(data);

  const onInputChange = (value) => {
    const inputValue = value.toUpperCase();

    const filteredArray = data.filter((item, index) => {
      return (
        item.phone.toUpperCase().indexOf(inputValue) > -1 ||
        item.name.toUpperCase().indexOf(inputValue) > -1 ||
        item.mail.toUpperCase().indexOf(inputValue) > -1
      );
    });
    setArrayList(filteredArray);
  };

  return (
    <div className="messages-tab">
      <div className="container">
        <h1 className="section__title">Rehberim</h1>
        <div className="box">
          <div className="group-titles">
            <div
              className={classNames('all-records', {
                active: contentName === 'group--1',
              })}
              onClick={() => {
                setGroupName('Tüm Kayıtlar');
                setContentName('group--1');
              }}
            >
              Tüm Kayıtlar
              <RightChevronIcon />
            </div>
            <div className="sub-groups">
              <ul>
                <li
                  className={classNames({ active: contentName === 'group--2' })}
                  onClick={() => {
                    setGroupName('Samsung Kullanıcıları');
                    setContentName('group--2');
                  }}
                >
                  <span>Samsung Kullanıcıları</span>
                  <RightChevronIcon />
                </li>
                <li
                  className={classNames({ active: contentName === 'group--3' })}
                  onClick={() => {
                    setGroupName('General Mobile Kullanıcıları');
                    setContentName('group--3');
                  }}
                >
                  <span>General Mobile Kullanıcıları</span>
                  <RightChevronIcon />
                </li>
                <li
                  className={classNames({ active: contentName === 'group--4' })}
                  onClick={() => {
                    setGroupName('Bizden Telefon Almamış Müşterileri');
                    setContentName('group--4');
                  }}
                >
                  <span>Bizden Telefon Almamış Müşterileri</span>
                  <RightChevronIcon />
                </li>
                <li
                  className={classNames({ active: contentName === 'group--5' })}
                  onClick={() => {
                    setGroupName('Son Telefon Satın Alma Tarihi 1 Yıld');
                    setContentName('group--5');
                  }}
                >
                  <span>
                    Son Telefon Satın Alma Tarihi 1 YıldSon Telefon Satın Alma
                    Tarihi 1 Yıld
                  </span>
                  <RightChevronIcon />
                </li>
              </ul>
            </div>
            <div className="new-group">
              <Button
                shape="round"
                type="ghost"
                onClick={() => {
                  setNewGroupModal(true);
                }}
              >
                <GroupsIcon />
                Yeni Grup
              </Button>
              <Modal
                title="Yeni Grup Oluştur"
                visible={newGroupModal}
                onCancel={() => setNewGroupModal(false)}
                footer={null}
              >
                <Form form={form} name="payment">
                  <Form.Item
                    name="new-group-name"
                    messageVariables={{ label: 'Grup Adı' }}
                    className="margin-bottom-0"
                  >
                    <Input type="text" name="new-group-name" label="Grup Adı" />
                  </Form.Item>
                  <div className="modal-action">
                    <Button
                      shape="round"
                      type="ghost"
                      onClick={() => setNewGroupModal(false)}
                    >
                      Vazgeç
                    </Button>
                    <Button
                      disabled
                      key="confirm"
                      type="primary"
                      onClick={() => setNewGroupModal(false)}
                    >
                      Kaydet
                    </Button>
                  </div>
                </Form>
              </Modal>
            </div>
          </div>
          <Tabs
            defaultActiveKey="1"
            onChange={(item) => {
              setContentName(`group--${item}`);
            }}
            renderTabBar={(props, Item) => {
              return <MobileTabBar props={props} item={Item} />;
            }}
          >
            <TabPane tab="Tüm Kayıtlar" key="1"></TabPane>
            <TabPane tab="Samsung Kullanıcıları" key="2"></TabPane>
            <TabPane tab="General Mobile Kullanıcıları" key="3"></TabPane>
            <TabPane tab="Bizden Telefon Almamış Müşterileri" key="4"></TabPane>
            <TabPane
              tab="Son Telefon Satın Alma Tarihi 1 YıldSon Telefon Satın Alma Tarihi 1 Yıld"
              key="5"
            ></TabPane>
          </Tabs>
          {contentName === 'group--1' ? (
            <div className="group-members">
              <div className="group-members__header">
                <strong className="group-members__title">
                  {groupName}
                  <span></span>
                </strong>
                <div className="group-actions">
                  <button
                    onClick={() => {
                      setAddRowModal(true);
                    }}
                    type="button"
                  >
                    <NewContact />
                    <span>Yeni Kişi</span>
                  </button>
                  <button
                    onClick={() => {
                      console.log('dışa aktar');
                    }}
                    type="button"
                  >
                    <ExportFileIcon />
                    <span>Dışa aktar</span>
                  </button>
                  <div>
                    <input
                      type="file"
                      ref={selectFileRef}
                      onChange={(e) => {
                        setFileList(e.target.files);
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setGroupImportFile(!groupImportFile)}
                    >
                      <ImportExcelIcon />
                      İçe Aktar
                      <DownChevronIcon />
                    </button>
                    {groupImportFile ? (
                      <div className="collapse">
                        <div className="select-ready-messages">
                          <div className="status">
                            <UploadIcon />
                          </div>
                          <div className="messages-area">
                            <span>Excel'den İçe Aktar</span>
                          </div>
                          <div className="upload-action">
                            <Button
                              type="ghost"
                              onClick={() => {
                                selectFileRef.current.click();
                                setImportFileModal(true);
                              }}
                            >
                              Seç
                            </Button>
                          </div>
                        </div>
                        <span>
                          Rehber kayıtlarınızı oluşturabileceğiniz örnek Excel
                          dosyasını indirmek için{' '}
                          <a href="/samples/ornek.xlsx" download>tıklayın.</a>
                        </span>
                      </div>
                    ) : null}
                  </div>

                  <Modal
                    title="Dosyayı İçeri Aktar"
                    visible={importFileModal}
                    onCancel={() => setImportFileModal(false)}
                    footer={null}
                  >
                    <Form form={form} name="import-file">
                      <Form.Item
                        name="group-name"
                        messageVariables={{ label: 'name' }}
                      >
                        <Input type="text" name="group-name" label="Grup Adı" />
                      </Form.Item>
                      <Form.Item
                        name="select-file"
                        messageVariables={{ label: 'file' }}
                      >
                        <SelectFile
                          uploaderRef={selectFileRef}
                          allowExtensions={["xlsx","xls","txt","zip","vcard"]}
                          type="file"
                          fileList={fileList}
                          title={<span>Excel'den İçe Aktar</span>}
                          icon={<UploadIcon />}
                        />
                      </Form.Item>
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setImportFileModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button
                          disabled
                          key="confirm"
                          type="primary"
                          onClick={() => setImportFileModal(false)}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </Form>
                  </Modal>

                  <Modal
                    title="Kişi Ekle"
                    visible={addRowModal}
                    onCancel={() => setAddRowModal(false)}
                    footer={null}
                  >
                    <Form form={form} name="add-row">
                      <Form.Item
                        name="add-row-number"
                        messageVariables={{ label: 'number' }}
                      >
                        <Input
                          type="tel"
                          name="add-row-number"
                          label="Telefon Numarası"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-name"
                        messageVariables={{ label: 'name' }}
                      >
                        <Input
                          type="text"
                          name="add-row-name"
                          label="Kişi Adı"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-mail"
                        messageVariables={{ label: 'e-mail' }}
                      >
                        <Input
                          type="mail"
                          name="add-row-mail"
                          label="E-Posta Adresi"
                        />
                      </Form.Item>
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setAddRowModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button
                          disabled
                          key="confirm"
                          type="primary"
                          onClick={() => setAddRowModal(false)}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </Form>
                  </Modal>
                </div>
              </div>
              <div className="group-members__search">
                <Input
                  prefix={<SearchIcon />}
                  placeholder="Tüm Kayıtlar İçerisinde Ara..."
                  autoComplete="off"
                  style={{ width: '100%' }}
                  onChange={(e) => onInputChange(e.target.value)}
                />
              </div>
              {isPc ? (
                <Table
                  columns={columns}
                  scroll={{ y: 610 }}
                  dataSource={arrayList}
                  className="table--guide"
                  pagination={{ total: 100, position: ['bottomCenter'] }}
                />
              ) : (
                <Table
                  columns={mobileColumns}
                  scroll={{ y: 610, x: 700 }}
                  dataSource={arrayList}
                  className="table--guide"
                  pagination={{ total: 100, position: ['bottomCenter'] }}
                />
              )}

              <Modal
                title="Kişiyi Düzenle"
                visible={rowEditModal}
                onCancel={() => setRowEditModal(false)}
                footer={null}
              >
                <Form form={form} name="edit-row">
                  <Form.Item
                    name="edit-row-number"
                    messageVariables={{ label: 'number' }}
                  >
                    <Input
                      type="tel"
                      name="edit-row-number"
                      label="Telefon Numarası"
                    />
                  </Form.Item>
                  <Form.Item
                    name="edit-row-name"
                    messageVariables={{ label: 'name' }}
                  >
                    <Input type="text" name="edit-name" label="Kişi Adı" />
                  </Form.Item>
                  <Form.Item
                    name="edit-row-mail"
                    messageVariables={{ label: 'e-mail' }}
                  >
                    <Input
                      type="mail"
                      name="edit-row-mail"
                      label="E-Posta Adresi"
                    />
                  </Form.Item>
                  <div className="modal-action">
                    <Button
                      shape="round"
                      type="ghost"
                      onClick={() => setRowEditModal(false)}
                    >
                      Vazgeç
                    </Button>
                    <Button
                      disabled
                      key="confirm"
                      type="primary"
                      onClick={() => setRowEditModal(false)}
                    >
                      Kaydet
                    </Button>
                  </div>
                </Form>
              </Modal>
            </div>
          ) : (
            <div className="group-members">
              <div className="group-members__header">
                <strong className="group-members__title">
                  {groupName}{' '}
                  <button onClick={() => setEditGroupName(true)} type="button">
                    <EditIcon />
                  </button>
                </strong>
                <div className="group-actions group-actions--v2">
                  <button
                    onClick={() => {
                      setAddRowModal(true);
                    }}
                    type="button"
                  >
                    <NewContact />
                  </button>
                  <button
                    onClick={() => {
                      console.log('dışa aktar');
                    }}
                    type="button"
                  >
                    <ExportFileIcon />
                  </button>
                  <button
                    onClick={() => {
                      console.log('sil');
                    }}
                    type="button"
                  >
                    <DeleteIcon />
                  </button>

                  <Modal
                    title="Kişi Ekle"
                    visible={addRowModal}
                    onCancel={() => setAddRowModal(false)}
                    footer={null}
                  >
                    <Form form={form} name="add-row">
                      <Form.Item
                        name="add-row-number"
                        messageVariables={{ label: 'number' }}
                      >
                        <Input
                          type="tel"
                          name="add-row-number"
                          label="Telefon Numarası"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-name"
                        messageVariables={{ label: 'name' }}
                      >
                        <Input
                          type="text"
                          name="add-row-name"
                          label="Kişi Adı"
                        />
                      </Form.Item>
                      <Form.Item
                        name="add-row-mail"
                        messageVariables={{ label: 'e-mail' }}
                      >
                        <Input
                          type="mail"
                          name="add-row-mail"
                          label="E-Posta Adresi"
                        />
                      </Form.Item>
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setAddRowModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button
                          disabled
                          key="confirm"
                          type="primary"
                          onClick={() => setAddRowModal(false)}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </Form>
                  </Modal>
                </div>
              </div>
              <div className="group-members__search">
                <Input
                  prefix={<SearchIcon />}
                  placeholder="Grup İçerisinde Ara..."
                  autoComplete="off"
                  style={{ width: '100%' }}
                  onChange={(e) => onInputChange(e.target.value)}
                />
              </div>
              {isPc ? (
                <Table
                  columns={columnsV2}
                  scroll={{ y: 610 }}
                  dataSource={arrayList}
                  className="table--guide"
                  pagination={{ total: 100, position: ['bottomCenter'] }}
                />
              ) : (
                <Table
                  columns={mobileColumnsV2Test}
                  scroll={{ y: 610, x: 700 }}
                  dataSource={arrayList}
                  className="table--guide"
                  pagination={{ total: 100, position: ['bottomCenter'] }}
                />
              )}

              <Modal
                title="Grup Adını Değiştir"
                visible={editGroupName}
                onCancel={() => setEditGroupName(false)}
                footer={null}
              >
                <Form form={form} name="payment">
                  <Form.Item
                    name="edit-group-name"
                    messageVariables={{ label: 'Grup Adı' }}
                    className="margin-bottom-0"
                  >
                    <Input
                      type="text"
                      name="edit-group-name"
                      label="Grup Adı"
                    />
                  </Form.Item>
                  <div className="modal-action">
                    <Button
                      shape="round"
                      type="ghost"
                      onClick={() => setEditGroupName(false)}
                    >
                      Vazgeç
                    </Button>
                    <Button
                      disabled
                      key="confirm"
                      type="primary"
                      onClick={() => setEditGroupName(false)}
                    >
                      Kaydet
                    </Button>
                  </div>
                </Form>
              </Modal>

              <Modal
                title="Kişiyi Düzenle"
                visible={rowEditModal}
                onCancel={() => setRowEditModal(false)}
                footer={null}
              >
                <Form form={form} name="edit-row">
                  <Form.Item
                    name="edit-row-number"
                    messageVariables={{ label: 'number' }}
                  >
                    <Input
                      type="tel"
                      name="edit-row-number"
                      label="Telefon Numarası"
                    />
                  </Form.Item>
                  <Form.Item
                    name="edit-row-name"
                    messageVariables={{ label: 'name' }}
                  >
                    <Input type="text" name="edit-name" label="Kişi Adı" />
                  </Form.Item>
                  <Form.Item
                    name="edit-row-mail"
                    messageVariables={{ label: 'e-mail' }}
                  >
                    <Input
                      type="mail"
                      name="edit-row-mail"
                      label="E-Posta Adresi"
                    />
                  </Form.Item>
                  <div className="modal-action">
                    <Button
                      shape="round"
                      type="ghost"
                      onClick={() => setRowEditModal(false)}
                    >
                      Vazgeç
                    </Button>
                    <Button
                      disabled
                      key="confirm"
                      type="primary"
                      onClick={() => setRowEditModal(false)}
                    >
                      Kaydet
                    </Button>
                  </div>
                </Form>
              </Modal>
            </div>
          )}

          <Modal
            title="Hazır Mesajlarım"
            visible={changeGroupModal}
            onCancel={() => setChangeGroupModal(false)}
            footer={null}
          >
            <div className="message-list">
              {changeGroupList.map((item, index) => (
                <div
                  onClick={() => {
                    setChangeGroupModal(false);
                  }}
                  className="message-list__item"
                  key={'message-item' + index}
                >
                  <p>{item}</p>
                  <div>
                    <span>Seç</span>
                    <DownChevronIcon />
                  </div>
                </div>
              ))}
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default GuidePage;
